export default "__VITE_ASSET__1e974280__"